import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { Label } from 'reactstrap';
import DropdownIndicator from '../React-Multiselect/DropdownIndicator';
import { REACT_SELECT_STYLES } from './config';

function UnControlledReactSelect({
  isMulti,
  options,
  defaultValue,
  selectHandler,
  closeMenuOnSelect,
  hideSelectedOptions,
  placeholder,
  noOptionsMessage,
  menuPlacement,
  valueProp,
  ...props
}) {
  const onChange = value => {
    if (selectHandler) {
      if (value) {
        //if the isMulti is enabled then we pass the array directly
        if (isMulti) {
          selectHandler(value);
        } else {
          selectHandler(value.value, value);
        }
      } else {
        selectHandler(null);
      }
    }
  };

  const { label, disable, clearable, loading, isSearchable } = props;

  return (
    <>
      {label ? (
        <Label htmlFor='string' className='pe-2'>
          {label}
        </Label>
      ) : null}
      <Select
        menuPlacement={menuPlacement}
        isClearable={clearable === false ? false : true}
        value={valueProp}
        isMulti={isMulti}
        onChange={onChange}
        options={options}
        noOptionsMessage={() => noOptionsMessage || undefined}
        closeMenuOnSelect={closeMenuOnSelect}
        hideSelectedOptions={hideSelectedOptions}
        isLoading={loading}
        defaultValue={defaultValue}
        isDisabled={disable}
        className={`custom-design ${props.className || ''} ${
          isMulti && valueProp?.length >= 1 ? 'single-option' : ''
        }`}
        isSearchable={isSearchable}
        placeholder={placeholder}
        styles={REACT_SELECT_STYLES}
        components={{ DropdownIndicator }}
      />
    </>
  );
}

UnControlledReactSelect.propTypes = {
  isMulti: PropTypes.bool,
  loading: PropTypes.bool,
  defaultValue: PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
      PropTypes.bool,
      PropTypes.object
    ])
  }),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool])
    })
  ),
  selectHandler: PropTypes.func,
  locId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  placeholder: PropTypes.string,
  clearable: PropTypes.bool,
  isSearchable: PropTypes.bool,
  closeMenuOnSelect: PropTypes.bool,
  hideSelectedOptions: PropTypes.bool,
  noOptionsMessage: PropTypes.string,
  className: PropTypes.string,
  menuPlacement: PropTypes.string,
  valueProp: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.object])
};

export default React.memo(UnControlledReactSelect);
